import { createFileRoute } from "@tanstack/react-router";
import { ErrorPageActions } from "@/components/error/error-page-actions";

export function Error500Component() {
	return (
		<div className="flex flex-col items-center justify-center min-h-[80vh] p-8 text-center">
			<h1 className="text-4xl font-bold mb-4">
				Something went wrong on our end
			</h1>

			<div className="mb-8">
				<img
					src="https://http.dog/500.jpg"
					alt="500 dog"
					className="rounded-lg shadow-lg max-w-md mx-auto dark:brightness-90"
				/>
			</div>

			<div className="max-w-lg mx-auto space-y-4">
				<p className="text-xl mb-4">
					We're looking into it — try refreshing the page.
				</p>

				<div className="text-gray-600 dark:text-gray-400">
					<p>Here are a few things you can try:</p>
					<ul className="list-disc list-inside mt-2">
						<li>Refresh the page</li>
						<li>Try again in a few minutes</li>
						<li>Go back to the previous page</li>
						<li>Head to the home page</li>
					</ul>
				</div>
			</div>

			<ErrorPageActions />
		</div>
	);
}

/* istanbul ignore start -- TanStack Router file route registration */
export const Route = createFileRoute("/_error/500")({
	component: Error500Component,
});
/* istanbul ignore end */
